import { createGlobalStyle } from "styled-components";

export const ZendeskGlobalStyled = createGlobalStyle`
    body iframe[name="Messaging window"], body iframe[name="Janela de mensagens"], body iframe[name="Jendela pesan"] {
        inset: unset !important;
        bottom: 16px !important;
        left: 130px !important;
        border-radius: 24px !important;
    }
`;
